import { NgModule, APP_INITIALIZER, ErrorHandler, PLATFORM_ID } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AmplifyAngularModule, AmplifyService, AmplifyModules } from "aws-amplify-angular";
import Auth from "@aws-amplify/auth";
import Analytics from "@aws-amplify/analytics";
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SortablejsModule } from "ngx-sortablejs";

import { ComponentsModule } from "./components/components.module";
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LucsService } from "./services/lucs.service";
import { IndicatorsService } from "./services/indicators.service";
import { ErrorHandlerService } from "./services/error-handler.service";
import { ConfigService } from "./services/config.service";
import { AuthInterceptor } from "./auth/auth.interceptor";
import { LoadingComponent } from "./loading/loading.component";
import { LanguageModule } from './language/language.module';
import { LanguageService } from './language/language.service';
import { AppStateService } from './appState.service';
import { LanguageInterceptor } from './interceptors/language.interceptor';

const initializerFactory: Function = (
    lucsServ: LucsService,
    indsServ: IndicatorsService,
    config: ConfigService,
    langServ: LanguageService,
    appState: AppStateService, 
) => {
    const language = langServ.detectBrowserLanguage();
    console.log("LOADING LANGUAGE: ", language);

    appState.setLanguage(language);

    // returns a function that returns a promise
    return () => Promise.all([
        lucsServ.load(),
        indsServ.load(),
        config.load(),
        langServ.loadLanguages(),
        langServ.load(language)
    ]);
};

@NgModule({
    declarations: [
        AppComponent,
        LoadingComponent,
    ],
    entryComponents: [],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot({
            // mode: 'md',
            swipeBackEnabled: false,
            hardwareBackButton: false,
        }),
        LanguageModule,
        AppRoutingModule,
        AmplifyAngularModule,
        ComponentsModule,
        SortablejsModule.forRoot({ animation: 150 }),
    ],
    providers: [
    
        StatusBar,
        SplashScreen,
        // Language Interceptor comes first
        { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },

        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: AmplifyService, useFactory: () => AmplifyModules({ Auth, Analytics }) },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: APP_INITIALIZER,
            useFactory: initializerFactory,
            deps: [ LucsService, IndicatorsService, ConfigService, LanguageService, AppStateService ],
            multi: true
        },
        { provide: PLATFORM_ID, useValue: 'browser' },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
